<template>
  <div id="app">
    <Header />
    <ShareBar></ShareBar>
    <keep-alive include="mallList">
      <router-view />
    </keep-alive>
    <div id="page1" class="section section6" ref="footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header-co';
import ShareBar from '@/components/ShareBar-co';
import Footer from '@/components/Footer-co';
export default {
  components: {
    Header,
    ShareBar,
    Footer
  }
}
</script>

<style lang="scss">
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // background-color: #000000;
  // color: #ffffff;
}
* {
  margin: 0;
  padding: 0;
}
body {
  font-family: "KiaSignatureRegular", "方正兰亭", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  padding-right: 0px !important;
}
.v-modal{
  position: relative;
}
.el-scrollbar .el-scrollbar__bar {
     opacity: 1 !important;
}

</style>
